import { useLocation, Outlet } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { useEffect } from 'react';

export default function AppLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  
  // Toggle audio robuste + anti-"ding" (sans changer l'UI)
  useEffect(() => {
    (function () {
      function toggleAudio(id: string) {
        const a = document.getElementById(id) as HTMLAudioElement | null;
        if (!a) return;
        try {
          if (a.paused || a.ended) {
            if (a.ended) a.currentTime = 0;
            const p = a.play(); (p as any)?.catch?.(() => {});
          } else {
            a.pause();
          }
        } finally {
          a.scrollIntoView({ behavior: "smooth", block: "center" });
          try { a.focus({ preventScroll: true }); } catch {}
        }
      }

      // Branche tous les boutons marqués data-audio-target
      document.addEventListener("click", (e) => {
        const btn = (e.target as HTMLElement).closest("[data-audio-target]") as HTMLElement | null;
        if (!btn) return;
        const id = btn.getAttribute("data-audio-target");
        if (id) {
          e.preventDefault();
          toggleAudio(id);
        }
      }, { capture: true });
    })();
  }, []);
  
  return (
    <>
      <Header variant={isHome ? 'transparent' : 'solid'} />
      <Outlet />
    </>
  );
}